import { render } from "./SearchVouchersView.vue?vue&type=template&id=00a999fd"
import script from "./SearchVouchersView.vue?vue&type=script&lang=ts"
export * from "./SearchVouchersView.vue?vue&type=script&lang=ts"
script.render = render

export default script